angular.module('wbDashboard').controller('ProfileSecurityControllerAurea', ['$scope', '$q', '$uibModal', 'User', 'Message', function ($scope, $q, $uibModal, User, Message) {
    $scope.pageData.errorMsg = null;

    $scope.password = {};

    $scope.passwordSubmit = function() {
        $scope.pageData.sending = true;
        $scope.pageData.sendingPassword = true;
        $scope.pageData.errorMsg = null;

        User.updatePassword($scope.password.current, $scope.password.new).then(function (response) {
            Message.set({
                "text" : "Your password has been updated",
                "type" : "success"
            });
            $scope.password = {};
            $scope.forms.password.$setPristine();
            $scope.forms.password.$setUntouched();
        }).catch(function (response) {
            if ("error" in response.data && "message" in response.data.error) {
                $scope.pageData.errorMsg = response.data.error.message;
            } else {
                $scope.pageData.errorMsg = 'There was an error updating your profile. Please email support@axosinvest.com';
            }
            $scope.forms.password.$setDirty();
        }).finally(function(){
            $scope.pageData.sending = false;
            $scope.pageData.sendingPassword = false;
        });
    };

}]);
